module.exports = __webpack_public_path__ + "media/images/common/avatar2-9722106bd22652f77ae8f8cb92c315c0.png";